var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampaignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "campaign",
    clipPath: "url(#clip0_2187_6335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.29027 6.39476L3.28006 8.00519C1.62725 8.44806 0.615405 10.081 1.03151 11.6339L1.78805 14.4574C2.20416 16.0103 3.8969 16.9185 5.54971 16.4756L7.05226 16.073L8.70472 22.2401C8.91277 23.0165 9.75914 23.4706 10.5855 23.2492C11.4119 23.0278 11.9179 22.2113 11.7098 21.4349L10.0574 15.2678L11.5599 14.8652L19.3786 16.8744C19.7492 16.9696 20.085 16.6303 19.986 16.2607L15.8897 0.973197C15.7907 0.603614 15.3302 0.47768 15.0568 0.74544L9.29027 6.39476ZM21.6942 7.61042C21.1911 5.73281 19.8657 4.27224 18.1732 3.48501L20.7038 12.9295C21.7798 11.4156 22.1973 9.48803 21.6942 7.61042Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2187_6335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignIcon);
export default __webpack_public_path__ + "static/media/campaign-icon.4fa89a2f726eb062832b513859dda740.svg";
export { ForwardRef as ReactComponent };